import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import contactsApp from "./contactsApp"
import DateFormaterReducer from '../actions/fetchDateFormater';
import UserRolePermissionsReducer from '../actions/fetchUserRolePermissions';
import authReducer from '../authSlice';
import { hrBaseApi } from 'app/services/HrBaseApi';

const exportReducers = history => {
    return combineReducers({
        router: connectRouter(history),
        contactsApp: contactsApp,
        getFetchDate: DateFormaterReducer,
        getUserRolePermissions: UserRolePermissionsReducer,
        auth: authReducer,
        [hrBaseApi.reducerPath]: hrBaseApi.reducer,
    });
};

export default exportReducers;

